export default {
    CountryDisplay: {
        DE: 'Germany',
        SG: 'Singapore',
        AT: 'Austria',
        FR: 'France',
        CH: 'Switzerland',
        BE: 'Belgium',
        GB: 'United Kingdom',
        NL: 'Netherlands',
        IT: 'Italy',
        ES: 'Spain',
        CZ: 'Czech Republic',
    },
    SharedErrors: {
        UNKNOWN: 'Something went wrong. Please try again.',
        VAT_EXEMPTION_NOT_ALLOWED_FOR_COMPANY:
            'A company in Germany of your type should be subject to vat.',
    },
    EditProfile: {
        edit1: 'Partner Data',
        edit2: 'Edit',
        cancel: 'Cancel',
        userInfo: 'Contractual Partner',
        beneficiaryDescription:
            'The contractual partner is beneficiary of credit notes.',
        billingAddress: 'Separate Recipient for Credit Notes',
        recipientContactDescription:
            'You can provide separate contact data for the recipient of the credit notes. The beneficiary for the credit notes still remains the contractual partner.',
        bank: 'Bank Details',
        saveSection: 'Save',
        contractDetails: 'Contract Details',
        changedNote: 'Last changed at %s',
    },
    TurnoverCard: {
        title: 'Credit Notes',
        loading: 'Loading Credit Notes...',
        noTurnover: 'You do not have a credit note yet.',
    },
    TurnoverItem: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
        corrected: 'corrected',
    },
    UsagePeriodsCard: {
        title: 'Usage Data',
        loading: 'Loading Usage Data...',
        noData: 'There is no usage data yet.',
    },
    UsagePeriodItem: {
        month: 'Month',
        cycles: 'Cycles',
        amount: 'Turnover',
    },
    ProfileBillingDataForm: {
        title: 'Settlement Details',
        description:
            'We use your bank details to transfer your turnover share at the beginning of the month.',
        errorLoading: "Something went wrong. Couldn't find settlement details.",
        accountholderName: 'Account Holder*',
        accountholderNameError: 'Please provide an account holder.',
        iban: 'IBAN*',
        ibanError: 'Please provide a valid IBAN',
        bic: 'BIC',
        bicHint: 'If left blank, the BIC will be filled automatically.',
        bicError: 'Please provide a valid BIC.',
        useSettlement: 'Bank details',
        useEmail: 'Receive monthly credit note document via e-mail',
        emailAddress: 'E-Mail Address*',
        emailAddressError: 'Please provide a valid e-mail address.',
        creditNotesEnabled: 'Credit notes enabled',
    },
    ProfileContractDetailsForm: {
        company_registration_number: 'Company Registration Number',
        setDefaults: 'Set Defaults',
        calculatedShare: 'WeWash turnover share adjusted by VAT:',
        vat_exempted: 'This accounting area is subject to sales tax.',
        vat_exemption_reason: 'Reason:',
        vat_id: 'VAT-ID / Tax id*',
        vatError: 'Please provide a valid VAT-ID / Tax id.',
        contractual_wewash_share: 'WeWash turnover share (from contract)',
        country_id: 'Country*',
        country_idError: 'Please provide a valid country.',
        contractual_type: 'Contractual Type',
        tenant: 'Tenant',
        pmsProvider: 'Property Management System',
        generalError: 'Something went wrong. Please check your data.',
        confirmContractualChangeTitle: 'Contractual Type Changed',
        confirmContractualChangeText:
            'Note: This change affects all laundry rooms and appliances within the accounting area.',
        confirmContractualChangeContinue: 'Change Contractual Type',
        confirmContractualChangeCancel: 'Cancel',
    },
    CancelContinueButtons: {
        cancel: 'Cancel',
        continue: 'Continue',
    },
    LoginEntry: {
        message: {
            one: 'You are already logged in as',
            two: '',
        },
        error: {
            UNKNOWN: 'Something went wrong. Please try again.',
            USER: 'Please log in using your WeWash Partner account data!',
            BLOCKED:
                'Your account is currently blocked. Please contact customer support team via support@we-wash.com.',
            LOGOUT: 'Please log in again.',
            WRONG_CREDENTIALS: 'Invalid login data',
        },
        index: 'Home',
        email: 'E-mail',
        password: 'Password',
        login: 'Log in',
        passwordReset: 'Forgot your password?',
        mainTitle: 'Confirm Login Data',
    },
    Registration: {
        registrationTitle: 'Partner Registration',
        registrationPostit1:
            'With this account you can manage one or multiple accounting areas and objects. You can setup your initial accounting area after completing your registration.',
        skip: 'Skip',
    },
    RegistrationBasicForm: {
        title: 'Welcome to WeWash!',
        description: 'Dear WeWash Partner,',
        description2:
            'please sign up providing contact and authentication data.',
        registerLabel: 'Sign up',
        language: 'Language*',
        languageGer: 'German',
        languageEng: 'English',
        salutation: 'Salutation',
        salutationMr: 'Mr',
        salutationMrs: 'Mrs',
        first_name: 'First name*',
        first_nameError: 'Please provide your first name.',
        last_name: 'Last Name*',
        last_nameError: 'Please provide your last name.',
        company_name: 'Company name*',
        company_nameError: 'Please provide a company name.',
        country_id: 'Country*',
        country_idError: 'Please provide a valid country.',
        phone: 'Phone*',
        phoneError: 'Please provide a phone number.',
        email: 'E-mail*',
        emailError: 'Please provide a valid e-mail address.',
        email_confirm: 'Repeat e-mail*',
        email_confirmError:
            'The e-mail addresses you provided do not coincide.',
        email_confirmHelp: 'To confirm your e-mail address please repeat it.',
        termsAndCond1: 'I hereby confirm that I have read and accepted the ',
        aGB: 'Terms of Utilization and Ordering',
        agbUrlRoute: '/nutzungsbedingungen',
        pp: 'Privacy Policy',
        ppUrlRoute: '/datenschutz',
        and: ' and ',
        termsAndCond2: ' .',
        accept_agbError:
            'Please confirm that you have read and accepted the Terms of Utilization and Ordering and Privacy Policy.',
        vat_exempted: 'This accounting area is subject to sales tax.',
        vat_id: 'VAT-ID / Tax id',
        vatError: 'Please provide a valid VAT-ID / Tax id.',
        password: 'Password*',
        passwordError: 'Please check the password rules.',
        passwordHelp:
            'The password needs at least 8 characters, one number and one special character.',
        password_confirm: 'Repeat password*',
        password_confirmError: 'The passwords you provided do not coincide.',
        generalError:
            'Something went wrong. Please check your data and try again.',
        errorNotFullyFilled: 'Please fill out all required fields.',
        errorEmail: 'Please provide a valid e-mail address.',
        errorPassword:
            'The password needs at least 8 characters, one number and one special character.',
        codeError: 'The activation code you entered is not valid.',
        duplicateUserAlert: 'E-mail address is already registered.',
        errorWrongActivation: 'The activation code you entered is not valid.',
    },
    CreatePartnerBasicForm: {
        registrationTitle: 'Create Accounting Area',
        title: 'Contract Details',
        descriptionInitialPartnerCreation:
            'Here you create your new accounting area. Please add a contact person as well as bank details for the monthly turnover share. Afterwards, you can add multiple residential properties and laundry rooms to your accounting area. In addition, you can add further accounting areas with independent accounting details later on.',
        description:
            'Here you create a new accounting area. Please add a contact person as well as bank details for the monthly share of turnover. You can add multiple residential properties and laundry rooms to your accounting area.',
        cancel: 'Cancel',
        generalError: 'Something went wrong. Please check your data.',
        contractualContactTitle: 'Contractual Partner',
        contractualContactDescription:
            'Please provide an address for your accounting area. It is used to ship the WeWash hardware and for the monthly credit notes.',
        billing_title: 'Settlement Details',
        billing_description:
            '<p>Please enter the bank account where you would like to receive the monthly turnover share for this accounting area. The monthly turnover share is calculated as follows:</p> <p> Number of cycles * price per washing/drying <br/> - WeWash commission <br/>= your turnover share</p>',
        finish: 'Submit',
        accountholderName: 'Account Holder*',
        accountholderNameError: 'Please provide an account holder.',
        iban: 'IBAN*',
        ibanError: 'Please provide a valid IBAN.',
        bic: 'BIC',
        bicError: 'Please provide a valid BIC.',
        postitTextInitialPartnerCreation:
            'The contact data is prefilled with the data you entered during registration. You can edit this information as required.',
        postitText:
            'One or more residential properties and laundry rooms can be managed under one accounting area, given that they have the same contact person and accounting data.',
        recipientContactTitle: 'Credit Note Recipient',
        recipientContactDescription:
            'You can provide separate contact data for the recipient of the credit notes. The beneficiary for the credit notes still remains the contractual partner.',
        recipientContactDisabled:
            'We send the credit notes to the contractual partner.',
    },
    ProfileContactDataForm: {
        chooseToUse: 'Enter this contact',
        phone: { label: 'Phone', error: 'Please provide a phone number.' },
        company: {
            label: 'Company Name*',
            error: 'Please provide a company name.',
        },
        supplementary_line1: { label: 'Additional Address', error: '' },
        supplementary_line2: { label: 'Additional Address 2', error: '' },
        supplementary_line3: { label: 'Additional Address 3', error: '' },
        name: { label: 'Name', error: '' },
        street_and_housenumber: {
            label: 'Street and house number*',
            error: 'Please provide a street and house number.',
        },
        city: { label: 'City*', error: 'Please provide a city.' },
        postal_code: {
            label: 'Post Code*',
            error: 'Please provide a valid post code.',
        },
        country: {
            label: 'Country*',
            error: 'Please provide a valid country.',
        },
        genericError: 'Something went wrong. Please check your data.',
        comboboxHelp: {
            openCombobox: 'Choose from the list',
            emptyList: 'Loading...',
            emptyFilter: 'You can enter a country, or choose from the list.',
        },
    },
    ContactAddressPreview: {
        description: 'Preview',
    },
    FieldContractualType: {
        RMS: 'RMS',
        ADMIN: '---',
        CITY_POP: 'City Pop',
        WWC: 'WeWash Care',
        WWB: 'WeWash Box',
        WWC_IDOS: 'WeWash Care i-Dos',
        WHITE_LABEL_WWB: 'White Label Service WWB',
        WHITE_LABEL_WWC: 'White Label Service WWC',
        WWC_MINIMUM_USAGE: 'WeWash Care with Minimum Usage',
        WWC_IDOS_MINIMUM_USAGE: 'WeWash Care with Minimum Usage and i-Dos',
    },
    FieldVatExemptionReason: {
        vat_id: 'VAT-ID',
        tax_number: 'Tax id',
        no_number: 'Not provided',
        vatError: 'Please provide a valid VAT-ID / Tax id.',
        byCountry: {
            DE: {
                SUBJECT_TO_VAT: 'This accounting area is subject to sales tax.',
                VAT_EXEMPT:
                    'This accounting area is not subject to sales tax e.g. due to the small business regulation (§19USG)',
                REVERSE_CHARGE:
                    'This accounting area is not subject to sales tax due to the reverse charge procedure (see §13b, Paragraph 2, No. 1 UStG)',
            },
        },
        default: {
            SUBJECT_TO_VAT: 'This accounting area is subject to sales tax.',
            VAT_EXEMPT:
                'This accounting area is not subject to sales tax e.g. due to the small business regulation',
            REVERSE_CHARGE:
                'This accounting area is not subject to sales tax due to the reverse charge procedure',
        },
        hintVerificationUnknown: '',
        hintVerificationPending: 'Verification of VAT-ID in process. This can take a few minutes.',
        hintVerificationTechnicalError:
            'A technical issue occurred while verifying the VAT-ID. WeWash will take care of it.',
        hintVerificationSuccess: 'VAT-ID has been successfully confirmed.',
        hintVerificationConfirmed: 'You have confirmed the VAT-ID.',
        hintVerificationNotChecked: 'VAT-ID verification not required.',
        hintVerificationFailure:
            'The VAT-ID could not be confirmed. Please review and change the VAT-ID if necessary.',
        hintVerificationMismatchedCompanyName:
            'The VAT-ID could not be confirmed. Your company name does not match "%s" as provided by the VAT Information Exchange System.',
        hintVerificationCompanyWithoutVat:
            'Legal entities like GmbH or AG are typically vat liable. Please check your settings again. You can confirm them as correct using "Confirm VAT settings".',
        textVerificationConfirm: 'Alternatively:',
        actionVerificationConfirm: 'Confirm VAT-ID',
        actionVerificationConfirmCompany: 'Confirm VAT settings',
        actionRefresh: 'Reload Status',
        modalConfirmText:
            'The VAT-ID could not be confirmed. In rare cases the verification of the VAT-ID via the VAT Information Exchange System can fail even if the VAT-ID is correct. In that case, you can confirm that the VAT-ID is correct.',
        modalConfirmTitle: 'Confirm VAT-ID?',
        modalConfirmConfirm: 'Confirm VAT-ID',
        modalConfirmReject: 'Cancel',
    },
    RegistrationActivationForm: {
        title: 'Activate Account',
        description:
            'Please enter the activation code you have just received via e-mail. If you have not received an e-mail, please check your spam folder. For further questions please send an e-mail to support@we-wash.com.',
        activate: 'Activate Account',
        resendVerificationCode: 'Resend Code',
        codeSent: 'Code was sent.',
        activationCode: 'Activation Code',
        activationCodeError: 'Please enter a valid activation code.',
        generalError:
            'Something went wrong. Please check the data you provided.',
        errorNotFullyFilled: 'Please fill out all fields.',
        errorEmail: 'Please provide a valid e-mail address.',
        errorPassword:
            'The password needs at least 8 characters, one number, and one special character.',
        codeError: 'The activation code you entered is not valid.',
        duplicateUserAlert: 'The e-mail address already exists.',
        errorWrongActivation: 'The activation code you entered is not valid.',
    },
    LoginForm: {
        title1: 'Partner Login',
        title2: '',
        infoTitle: '',
        infoText: 'Please log in using your e-mail address and password.',
    },
    Dashboard: {
        Postit3: {
            title: 'Incomplete partner data.',
            text1: 'Please complete your contact and bank details.',
            text2: 'Please complete your bank details.',
            text3: 'Please complete your contact data.',
        },
    },
    DashboardStatistics: {
        statistics1: 'Statistics Accounting Area',
        statistics2: 'Current Month',
        numberOfUsers: 'Users',
        numberOfCycles: 'Cycles',
        wonThisMonth: 'Turnover',
        goToDetails: 'View more details',
    },
    VerticalNavigation: {
        myTitle: 'Accounting Area',
        weWash: 'for',
        editPartnerData: 'Accounting Data',
        dashboard: 'Dashboard',
        payment: 'Credit Notes',
        partnerInvoices: 'Invoices',
        roles: 'Access Management',
        operationalContacts: 'Contacts',
        objects: 'Residential Properties',
        downloads: 'Downloads',
        customerId: 'Customer ID:',
        usageData: 'Usage Data',
    },
    ObjectsOverview: {
        object: 'Residential Property',
        objects: 'Residential Properties',
        turnover: 'Turnover',
        numberOfUsers: 'Users',
        numberLocations: 'Laundry Rooms',
        numberOfOperationContacts: 'Contacts',
        addObject: 'Add Residential Property',
        objectFilterHint: 'Filter by street, post code or city name.',
    },
    ObjectStatisticsCard: {
        title: 'Statistics Residential Property',
        title2: 'Current Month',
        numberOfUsers: 'Users',
        numberOfCycles: 'Cycles',
        wonThisMonth: 'Turnover',
    },
    ObjectStatistics: {
        turnover: 'Turnover current Month',
        users: 'Users current Month',
    },
    ObjectsDetails: {
        locations: 'Laundry Rooms',
        editObject: 'Edit Residential Property',
        location: 'Laundry Room',
        numberOfAppliances: 'Number of Appliances',
        addLocation: 'Add Laundry Room',
        warnOperationalContactsText:
            'Please provide an operational contact for each of your properties. We will contact this person regarding operational matters, e.g. if an appliance needs maintenance.',
        warnOperationalContactsButton: 'Add contact',
    },
    Navigation: {
        myWeWash: 'Dashboard',
        help: 'Help',
        contact: 'Contact',
        logout: 'Log out',
        selectPartner: 'Accounting Areas',
        partnerManagerAccount: 'Manage Account',
    },
    Footer: {
        imprint: 'Legal Notice',
        data: 'Privacy Policy',
        imprintLink: 'https://we-wash.com/en/legal-notice/',
        privacyPolicyLink: 'https://we-wash.com/en/privacy-policy/',
    },
    Content: {
        all: 'All',
        elements: 'Elements',
        open: 'Open',
        register: 'Registration',
        process: 'Process',
        to: '',
        dashboard: 'Dashboard',
    },
    General: {
        save: 'Save',
        remove: 'Remove',
        cancel: 'Cancel',
        edit: 'Edit',
        didYouKnow: 'Did you know?',
        refresh: 'Refresh',
    },
    Breadcrumbs: {
        startPage: 'Home',
        objects: 'My Residential Properties',
        'create-object': 'Add Residential Property',
        'create-location': 'Add Laundry Room',
        'create-appliance': 'Add Appliance',
        profile: 'Edit Accounting Area',
        turnover: 'Turnover',
        '/help': 'Help',
        overview: 'Edit',
        password: '1. Password ',
        partner: '2. Contact Person ',
        address: '3. Accounting Address',
        bank: '4. Bank details for this accounting area',
        vip: 'Manage Prices',
        selectLocationPricing: 'Select location to set prices',
    },
    CreateAppliance: {
        add1: 'Add',
        add2: 'Appliance',
        headline: 'Information about the Appliance',
        description: '',
        cancel: 'Cancel',
        save: 'Add appliance',
        Postit1: {
            text1: 'Please add:',
            text2: 'Description: We recommend to add the manufacturer designation of the appliance (e.g. Bosch HomeProfessional WTY87641CH).',
            text3: 'Choose the appliance type.',
            text4: 'Fill in the serial number (W4CDLXXX) and the associated short name (W1, T1).',
            text5: 'You can find the serial number on the left side of your WeWash Box above the bar code.',
        },
        generalError: 'Failed to create the appliance.',
    },
    EditAppliance: {
        delete: 'Delete',
        headline: 'Appliance Information',
        description: '',
        cancel: 'Cancel',
        saveSection: 'Save',
        status_title: 'Appliance State',
        installationVerificationTitle: 'Test Cycle',
        statusPostit: {
            title: 'State',
            text1: 'Usage State: Indicates if the appliance is shown as available in the user app.',
            text2: 'Operational State: Indicates if the appliance is activated, deactivated for maintenance or in a test cycle.',
        },
        verificationCyclePostit: {
            title: 'Test Cycle',
            text: 'When the test cycle is requested, the appliance is immediately deactivated for app bookings. At the same time, the appliance is automatically activated within a few minutes so that a test cycle can be started in the laundry room within 16 hours. After a successful / completed test cycle, the appliance is activated.',
        },
        deleteModal: {
            title: 'Delete Appliance?',
            description:
                'Deleting an appliance will stop tracking usage on that appliance. You can then re-use the WeWash Box to setup another appliance.',
            confirm: 'Delete Appliance',
            cancel: 'Cancel',
        },
    },
    ApplianceBasicForm: {
        local_name: 'Description (Manufacturer, Model)*',
        local_name_error: 'Please add a description.',
        short_name: 'Short Name*',
        short_name_default: '...',
        short_name_error: 'Please add a short name.',
        short_name_duplicate_error:
            'This short name is assigned to another appliance.',
        appliance_type: 'Appliance Type*',
        appliance_type_error: 'Please choose an appliance type.',
        type_w: 'Washing Machine',
        type_d: 'Dryer',
        contractual_type: 'Contractual Type',
        serial_number: 'WeWash Box Serial Number*',
        serial_number_input_error: 'Invalid serial number',
        serial_number_input_hint: 'Please enter a serial number',
        connected: '(Connected)',
        inputVib: 'WeWash Article Number',
        inputVibBadMatch: 'Article number does not match appliance type.',
        optionUnknownVib: '(Unknown/No product code)',
        inputManufacturingBatch: 'Batch number',
        inputModelGroup: 'Model Group*',
        inputModelGroupBadMatch: 'Model group does not match appliance type.',
        controlType: 'Connection Type of the Appliance',
        signalType: 'Appliance connected via payment signal (recommended)',
        powerType: 'Appliance connected via power supply (max. 16 A per phase)',
        controlTypes: {
            POWER: {
                title: "Household-like appliances that don't need power to open door",
                descriptions: [
                    'WeWash Box disconnects the power supply directly after cycle ended',
                    'Examples: Electrolux myPRO, all other domestic appliances without payment interface',
                ],
            },
            POWER_CONSTANT: {
                title: 'Household-like appliances that need power to open door',
                descriptions: [
                    'The WeWash Box keeps the power supply after cycle ended, to allow door opening',
                    'Only certain Miele Professional SmartBiz and old Miele Domestic washing machines need this setting',
                ],
            },
            PAYMENT_SIGNAL: {
                title: 'Electrolux Professional without I/O Card',
                descriptions: ['Pulsed onetime signal (e.g. 0.5s length)'],
            },
            PAYMENT_SIGNAL_FULL_DURATION: {
                title: 'Miele Professional in Time Mode',
                descriptions: [
                    'Signal until cycle ends',
                    'Other brands: Electrolux Professional with I/O card and the corresponding setting',
                ],
            },
            PAYMENT_SIGNAL_DURING_LOADING: {
                title: 'Miele Professional in Program Mode',
                descriptions: [
                    'Signal until cycle starts',
                    'Typical setting, if appliances has been operated with coin/jeton machine before',
                    'Other brands: IPSO, Primus, Huebsch',
                ],
            },
        },
        professionalApplianceHeader: 'Professional Appliance',
        professionalApplianceLabel:
            'Is the appliance a professional appliance running in program mode?',
        constantPowerSupplyHeader: 'Electric Door Lock',
        constantPowerSupplyLabel:
            'Does your appliance need power supply to open the door (e.g. Miele washing machines)?',
        typeWLabel: 'W',
        typeTLabel: 'T',
        errorTags: {
            UNDEFINED: 'Error assigning the appliance',
            SERIALNUMBER_ALREADY_ASSIGNED:
                'Serial number already assigned to another appliance',
            LOCATION_ALREADY_HAS_ONE_HUB_SERIAL_NUMBER:
                'Another hub is already assigned to this laundry room',
            SERIALNUMBER_UNAVAILABLE: 'Invalid serial number',
        },
        filterPlaceholder: 'Limit selection',
    },
    ApplianceStatusForm: {
        state: 'Usage State',
        disabled: 'Disabled',
        applianceState: {
            IDLE: 'Ready For Use',
            RESERVED: 'In Use',
            READY_FOR_USE: 'In Use',
            ACTIVE: 'In Use',
            COMPLETE: 'In Use',
            POWER_OFF: 'Ready For Use',
        },
        operationalStateLabel: 'Operational State',
        operationalState: {
            OPERATIONAL: 'Activated',
            NON_OPERATIONAL: 'Deactivated for Maintenance',
            INSTALLATION_VERIFICATION: 'Test Cycle Activated',
            BLIND_MAINTENANCE: 'Deactivated for Maintenance',
            CLIENT_INSTALLATION: 'Deactivated for Maintenance',
            NOT_CONFIGURED: 'No connection / invalid serial number',
        },
        generalError: 'Something went wrong. Please try again later.',
    },
    InstallationVerificationForm: {
        statusLabel: 'State',
        status: {
            IN_PREPARATION: 'Requested',
            LOADING_PHASE: 'Appliance can be started',
            LOADING_PHASE_CANCEL_REQUESTED: 'Cancel requested',
            APPLIANCE_RUNNING: 'Appliance is running',
            PICKUP_PHASE: 'Analysing Data',
            CANCELED: 'Cancelled',
            SUCCESS: 'Successful',
            FAILURE: 'Failed',
            EXPIRED: 'Expired',
        },
        requestTime: 'Request Time of Last Test Cycle',
        startVerification: 'Request Test Cycle',
        cancelVerification: 'Cancel Test Cycle',
        generalError:
            'Something went wrong. Please refresh and then try again.',
        cycleAlreadyStarted:
            'Cancellation is no longer possible. The appliance was already started.',
        verificationAlreadyFinished: 'The verification cycle already finished.',
        verificationNotFinished:
            'The previous verification cycle did not finish yet.',
        verificationNotAllowedDuringMaintenance:
            'Verification cycle not possible during maintenance.',
    },
    Popup: {
        contact: {
            title: 'Contact Us',
            callUs: 'Call',
            email: 'E-mail',
        },
        help: {
            title: 'Help',
            text1: 'You can contact us if you need assistance.',
            emailtitle: 'E-mail',
            email: 'support@we-wash.com',
            phonetitle: 'Service - Phone',
            phone: '+49 89 740 55 44 00',
        },
    },
    CreateObject: {
        add1: 'Add',
        add2: 'Residential Property',
        cancel: 'Cancel',
        delete: 'Delete',
        address: 'Residential Property',
        info: 'Information on Residential Property (optional)',
        management: 'Management of Residential Property',
        text1: 'Adding a new Residential Property is very easy.',
        text2: 'Add the address.',
        text3: 'Add specific information on your residential property for an optimal setup.',
        createObject: 'Add Residential Property',
        saveSection: 'Save',
        Postit1: {
            title: 'Address',
            text1: 'Please add the complete address of your property here. Fields without * are optional and do not need to be filled out.',
        },
        Postit2: {
            text1: 'To achieve an optimal setup of your laundry room configuration please specify the mansion type as well as the number of housing units.',
        },
        operationalContactsTitle: 'Contact',
    },
    EditObject: {
        edit1: 'Edit',
        edit2: 'Residential Property',
        cancel: 'Cancel',
        delete: 'Delete',
        address: 'Residential Property',
        info: 'Supplementary Information on Residential Property',
        management: 'Management of Residential Property',
        saveSection: 'Save',
        generalError: 'Something went wrong. Please try again later.',
        locationExist:
            'The residential property still holds laundry rooms and / or open turnover for the current month. Please remove all laundry rooms from the property and wait until the next accounting month.',
        locationHasCreditNotes:
            'The residential property still holds laundry rooms and / or open turnover for the current month. Please remove all laundry rooms from the property and wait until the next accounting month.',
        deleteModal: {
            title: 'Delete Property?',
            description:
                'If you delete the residential property, you will not receive further income from them.',
            confirm: 'Delete Property',
            cancel: 'Cancel',
        },
    },
    ObjectAddressForm: {
        street: 'Street*',
        streetError: 'Please provide a street.',
        city: 'City*',
        cityError: 'Please provide a city.',
        description: 'Additional Address',
        postalcode: 'Post Code*',
        postalcodeError: 'Please provide a post code.',
        country_id: 'Country*',
        country_idError: 'Please provide a country.',
        housenumber: 'House Number*',
        housenumberError: 'Please provide a house number.',
        propagateChangesToLocations:
            'Propagate address changes to all associated locations',
    },
    ObjectInfoForm: {
        mansion_type: 'Mansion Type',
        num_of_machines: 'Number of Appliances',
        num_of_machinesError: 'Please provide the number of appliances.',
        housing_units: 'Housing Units',
        housing_unitsError: 'Please provide the number of housing units.',
        choose: 'Please choose',
        optionMultiFamilyHouse: 'Multifamily House',
        optionStudentHousing: 'Student Housing',
        optionCampsite: 'Campsite',
        optionClinic: 'Clinic',
        optionServicedApartment: 'Serviced Apartment',
        optionMicroLiving: 'Micro Living',
        optionSeniorLiving: 'Senior Living',
        optionOtherNotKnown: 'Other / Not Known',
        optionHostel: 'Hostel',
        optionHotel: 'Hotel',
        optionStaffHousing: 'Staff Housing',
        optionTruckStop: 'Truck Stop',
        optionVacationApartment: 'Vacation Apartment / Home',
        optionFittersFlat: "Fitter's Flat",
        optionPublicLaundrette: 'Public Laundrette',
        alert: 'Number of Appliances',
    },
    LocationPositionForm: {
        details: 'Please set the pin to the correct location on the map.',
        invalidTimezoneError:
            'WeWash ist not available at this GPS location. Please contact support@we-wash.com.',
    },
    CreateLocation: {
        create1: 'Add',
        create2: 'Laundry Room',
        location: 'Set GPS Location',
        cancel: 'Cancel',
        delete: 'Delete',
        price: 'Prices.',
        createLocation: 'Create Laundry Room',

        Postit1: {
            title: 'Create Laundry Room',
            text1: 'Please add a laundry room description. This description should be self-explanatory and easy to understand, as it will help the users to identify the correct laundry room (e.g. laundry room 1st floor).',
            text2: 'Optionally, you can specify the number of housing units as well as the number of appliances each housing unit can access.',
            buttonText: 'Get more information',
        },
        Postit2: {
            title: 'Prices',
            text1: 'Set the price per washing and drying cycle. This price will be charged to the users for their cycles and credited to you less our commission.',
            text2: 'The laundry room note is shown to app users and can be used to provide further information (e.g. limited operational times).',
        },
    },
    EditLocation: {
        create1: 'Laundry Room',
        create2: '',
        location: 'Set GPS Location',
        cancel: 'Cancel',
        delete: 'Delete',
        note: 'Note for the Users',
        saveSection: 'Save',
        generalError: 'Something went wrong. Please try again later.',
        applianceExistError:
            'The laundry room still holds appliances. Please remove them first.',
        errorTags: {
            UNKNOWN: 'The laundry room could not be saved.',
            LOCATION_ALREADY_EXISTS:
                'This description is already used by another laundry room in this residential property.',
            INPUT_TOO_LONG: 'Laundry Room Note is too long.',
            SERIALNUMBER_IN_USE:
                'Serial number cannot be changed because it is also used by an appliance.',
        },
        deleteModal: {
            title: 'Delete Laundry Room?',
            description:
                'Deleting the laundry room will only work if you have currently no appliances in it.',
            confirm: 'Delete Laundry Room',
            cancel: 'Cancel',
        },
    },
    LocationCostsForm: {
        note: 'Laundry Room Note (optional)',
        note_notif: 'Shown to users in the app',
        note_error: 'Should not be longer than 250 characters.',
        washer_cost: 'Price Washing* (in %s)',
        dryer_cost: 'Price Drying* (in %s)',
        washer_cost_error: 'Please add a price.',
        dryer_cost_error:
            'If you do not offer drying, please set the price to 0.',
        cost_calculator_action:
            'We offer you a tool to choose good prices. Click here to visit the Usage Price Calculator.',
        cost_calculator_link: 'https://we-wash.com/nutzungspreiskalkulator/',
    },
    LocationBasicForm: {
        name: 'Description of Laundry Room*',
        num_of_appartments:
            'How many housing units have access to this laundry room?',
        reservation_minutes: 'Reservation time',
        pickup_minutes: 'Pickup time',
        booking_minutes: 'Booking time',
        booking_logic: 'Which booking logic does this laundry room use?',
        name_error: 'Please provide a description.',
        name_duplicate_error:
            'This description is already used by another laundry room in this residential property.',
        num_of_appartments_error: 'Please provide a number.',
        reservation_minutes_error: 'Please provide a reservation time.',
        pickup_minutes_error: 'Please provide a pickup time.',
        minutes: ' Minutes',
        time_label:
            'How long may users take to load and start the machine, or pickup their laundry after completion? ',
        time_label_with_user_direct_booking:
            'For how long may users reserve a machine? How long may users take to pickup their laundry after completion?',
        time_label_for_booking_time:
            'How long may users take to load and start the machine?',
        bookingLogicEnum: {
            USER_DIRECT_BOOKING: 'User Direct Booking',
            APPLIANCE_START: 'Appliance Start',
            CALENDAR: 'Laundry Calendar',
        },
        gateway_serial_number_input_error: 'Invalid serial number',
        gateway_serial_number_input_hint: 'Please enter a serial number',
        gateway_serial_number_dropdown: 'Serial Number of the Hub',
        gateway_serial_number_help:
            "The 'Hub' is the WeWash Box with the attached antenna. It establishes the connection for the WeWash Boxes in the laundry room. You can add the serial number later, during the installation.",
        optional: '(optional)',
        connected: '(Connected)',
    },
    VipUserPricing: {
        title: 'Manage Prices',
        cancel: 'Back',
    },
    VipAddUserCard: {
        title: 'Activate Users for Reduced Prices',
        submit: 'Add Users',
        infoText: 'Add new users based on the Customer ID.',
        explanation:
            'Add new users based on the Customer ID. You can add multiple users into the field, e. g. 123456789, 123456780, 123456786',
        newEntriesLabel: 'Customer ID(s)',
        errors: {
            DUPLICATE_ENTRIES: 'Your input contains duplicate entries.',
            OTHER_ERROR: 'Unknown error',
            UNKNOWN_USER: 'Customer ID is not known',
        },
        reportTitle: 'Report',
        closeReport: 'Close',
        successfulSummary: 'Successfully added %s user(s).',
        alreadyExistsSummary: '%s user(s) had been added before.',
        errorSummary: 'Could not add the following users:',
    },
    FrequentActionCard: {
        title: 'Quick Links',
        setPricesAction: 'Adjust Prices',
        addBankDataAction: 'Add Bank Data',
    },
    HighlightedActions: {
        priceSuggestionText: 'We recommend you to adjust the usage prices.',
        priceSuggestionAction: 'Check recommendation',
        addBankDataText:
            'To receive your turnover share, we need settlement details from you.',
        addBankDataAction: 'Add data',
        addressVatinText:
            'The VAT-ID could not be confirmed. Please review your VAT-ID.',
        addressVatinAction: 'Review',
        addOperationalContactsText:
            'Please provide an operational contact for each of your properties. We will contact this person regarding operational matters, e.g. if an appliance needs maintenance.',
        addOperationalContactsAction: 'Assign contact',
    },
    VipSelectLocationCard: {
        locationName: 'Laundry Room',
        locationAddress: 'Address',
        title: 'Reduced Prices',
        back: 'Back',
        explanation:
            'In which laundry room do you want to configure the reduced prices?',
        loading: 'Fetching laundry rooms...',
        empty: 'No laundry rooms defined yet.',
    },
    LocationsDetails: {
        propertyLink: 'Property Link',
        connectivity: 'Connectivity',
        vipUserPricingButton: 'Manage Prices',
        connectivityStateLabel: 'State',
        connectivityState: {
            INITIAL: 'Unverified',
            UP: 'Connected',
            DOWN: 'Disconnected (< 15 min.)',
            WARNING: 'Disconnected (< 60 min.)',
            CRITICAL: 'Disconnected (> 60 min.)',
            null: 'Unverified',
            undefined: 'Unverified',
        },
        connectivityCheckStateLabel: 'Check',
        connectivityCheckState: {
            NONE: 'Not Requested',
            REQUIRED: 'Requested',
            IN_PROGRESS: 'In Progress',
        },
        connectivityCheckUpdateTime: 'Time of Last Check',
        requestConnectivityCheck: 'Check Connectivity',
        generalError: 'Something went wrong. Please try again later.',
        add1: 'Add',
        add2: 'Appliance',
        cancel: 'Cancel',
        settings: 'Settings',
        edit: 'To Laundry Room Details',
        description: 'Description',
        shortText: 'Short Name',
        serialNumber: 'WeWash Box Serial Number',
        note: 'Note',
        appliances: 'Appliances',
        typeWLabel: 'W',
        typeDLabel: 'T',
        disabled: 'deactivated',
        hotelCode: 'Hotel Code',
        Postit1: {
            title: 'The Laundry Room',
            text1: 'On this page you can:',
            text2: 'Add Appliances to your laundry room.',
            text3: 'Review and modify existing appliance.',
            text4: 'Edit your Laundry Room',
        },
        connectivityPostit: {
            title: 'Note for installation',
            text: 'Make sure that the serial number is correct and check connectivity for new installations, especially when the status is “Unverified.”',
        },
        managePricing: 'Manage Pricing',
        prices: 'Current Prices',
        washing: 'Washing',
        drying: 'Drying',
        phoneUserPostit: {
            title: 'Laundry Room Phone',
            usageNote:
                'Phone users can call this number to book a washer or dryer.',
            ratesNote: '* Local rates apply; mobile rates may vary.',
            unknownPhoneNumber: 'n/a',
        },
    },
    InstallationLinkCard: {
        title: 'Installation',
        description:
            'For the installation, create a link. You can send the link to a technician to setup appliances. With the link, they can configure the appliances and WeWash boxes on site themselves.',
        installationLink: 'Installation Link',
        technicianBoardLinkPre: 'Access the',
        technicianBoardLinkText: 'Technician Board',
        day: 'day',
        days: 'days',
        createAction: 'Create Link',
        modalClose: 'Cancel',
        expires: 'Expires in',
        invalid: 'Expired',
        emailAction: 'Send via Email',
        emailSuccess: 'Sent to',
        extendAction: 'Extend',
        revokeAction: 'Revoke',
        revokeConfirmTitle: 'Revoke Installation Link',
        revokeConfirmMessage:
            'Are you sure you want to revoke the installation link?',
        emailTitle: 'Send Email with Link',
        emailMessage:
            'Using an installation link the laundry room can be set up on site. The link can be shared and can also be used without an account.',
        recipientLabel: 'Recipient',
        recipientInvalid: 'Please provide a valid e-mail address',
    },
    OrderPostit: {
        title: 'Order WeWash Boxes',
        text: 'If you want to order WeWash Boxes, please leave us a message with the number of your appliances. We will get back to you promptly to discuss the details.',
        messageLabel: 'Your Message',
        message_error: 'Please send us a message',
        buttonLabel: 'Send non-binding request',
        confirmationText:
            'Thank you for your request. We will get back to you as soon as possible.',
    },
    PasswordResetRequest: {
        resetMessage:
            'To reset your password, please enter the e-mail address you signed up with.',
        email: 'E-Mail',
        submit: 'Reset password',
        login: 'Back to Login',
        title: 'Reset Password',
        invalidEmail: 'Please provide a valid e-mail address.',
        emailSentPreEmail: "We've sent an e-mail to reset your password to",
        emailSentPostEmail:
            '. Please follow the instructions in the e-mail. If you did not receive an e-mail, please check your spam folder. For further questions please send an e-mail to support@we-wash.com.',
    },
    PasswordResetWrapper: {
        title: 'Reset Password',
    },
    PasswordResetForm: {
        badKey: 'The link to reset your password has expired. Please go to the login page to request another password reset e-mail.',
        resetMessage: 'Please provide your new password.',
        email: 'E-mail',
        confirmCode: 'Validation Code',
        submit: 'Reset Password',
        login: 'Back to Login',
        success:
            'Your password has been successfully reset. You can now login using your new password.',
        title: 'Reset Password',
        invalidEmail: 'Please provide a valid e-mail address.',
        password: 'Password',
        passwordError: 'Please provide a secure password.',
        passwordHelp:
            'The password needs at least 8 characters, one number, and one special character.',
        passwordConfirm: 'Repeat Password',
        passwordConfirmError: 'The passwords you provided do not coincide.',
    },
    PriceFormat: {
        language: 'en',
        decimalSeperator: '.',
        thousandSeperator: ',',
        moneyFormat: '%v%s',
        currencySymbol: {
            EUR: '€',
            YEN: '¥',
            SGD: 'S$',
            USD: '$',
            GBP: '£',
        },
    },
    ReturningPage: {
        title: 'Thank you',
        mainText:
            'Thank you for adding a payment method. Please <strong>close this window</strong> and return to the WeWash App.',
        buttonText: 'Continue',
    },
    PartnersOverview: {
        title: 'Accounting Areas',
        titlePartnerByLocation: 'Search by Location ID',
        confirm: 'Enter Accounting Area',
        newPartner: 'Add Accounting Area',
        titlePartnerId: 'Partner ID / Customer ID',
        titleContact: 'Contact Person',
        titleCompany: 'Company',
        titleCreditNoteRecipient: 'Credit Note Recipient',
        titleAddress: 'Company Address',
        titleButton: '',
        postitText:
            '<p>In an accounting area you can manage one or multiple residential properties sharing the same commercial terms and accounting process.</p><p>Properties with different data should be added to a new accounting area.</p>',
        titleCardTitle: 'Accounting Areas',
        titleCardSubtitle: '',
        partnerFilterHint:
            'Filter by credit note recipient, street, company name, ...',
        partnerFilterHintFS:
            'Filter by credit note recipient, street, partner ID, ...',
        searchByLocationId: 'Search by location ID',
    },
    Downloads: {
        userInformation: 'User Information Material',
        laundryRoomInformation: 'Laundry Room Information Material',
        partnerBoardInstructions: 'Partner Board Guide',
        name: 'Name',
        language: 'Language',
        postIt: {
            text1: 'Here you can find information material for users and laundry rooms.',
            text2: 'We will gladly send you the printed version of our information material by post. Please contact installation@we-wash.com in this regard.',
        },
    },
    PartnerUsageData: {
        listTitle: 'List',
        configurationTitle: 'Automatic Subscription',
    },
    UsageDataSubscriptionConfigurationForm: {
        genericError: 'Please check your inputs.',
        subscriptionsIntro:
            'You can automatically receive a CSV file containing the monthly usage data. For this, please provide a recipient e-mail address. Please choose if you want the monthly report at the end of the month or wish to receive incremental updates every day.',
        subscriptionType: 'Frequency of e-mail',
        subscriptionTypes: {
            NONE: 'never',
            MONTHLY: 'monthly',
            CUMULATIVE_DAILY: 'daily',
        },
        emailAddress: 'E-mail address',
        emailAddressError: 'Please input an email address.',
        reception: 'Reception Accounts',
        receptionError:
            'Please provide a comma-separated list of customer-ids - e. g. "400112233, 400223344"',
        housekeeping: 'Housekeeping Accounts',
        housekeepingError:
            'Please provide a comma-separated list of customer-ids - e. g. "400112233, 400223344"',
    },
    DetailedUsageDataScreen: {
        loading: 'Loading...',
        error: 'Error.',
        title: 'Usage Data',
        months: {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December',
        },
    },
    UsageReportTable: {
        headerTime: 'When',
        headerAppliance: 'Appliance',
        headerLaundryRoom: 'Laundry Room',
        headerPrice: 'Price',
        headerBookingType: 'Booking Type',
        empty: 'No usage recorded.',
        download: 'Download as CSV',
    },
    UsageOverviewChart: {
        months: {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December',
        },
    },
    OAuthPropertyLinkForm: {
        propertyManagementSystemProviderDescription:
            'Property Management System Provider',
        hotelCodeDescription: 'Hotel code',
        hotelCodeLinkDescription: 'Guest Stay Login Link',
        enterEmailForOAuthLandingPageRequest: 'Enter e-mail for Property Link',
        requestOAuthLandingPageForLocation: 'Generate Property Link Code',
        requestNewOAuthLandingPageForLocation:
            'Regenerate New Property Link Code',
        propertyLinkUrlDescription: 'Property-Link URL',
        propertyLinkCodeDescription: 'Property-Link Code',
        copyPropertyLinkUrl: 'Copy',
        apaleoStepsTitle: 'Connect to Apaleo',
        apaleoStepsLocationExists: 'Laundry room created',
        apaleoStepsCreateLink: 'Link for Partner provided',
        apaleoStepsWaitForPartner: 'Partner granted access to Apaleo',
        apaleoStepsAssignProperty: 'Apaleo property selected',
        descriptionWaitForPartner:
            'The link can be used to grant access to the Apaleo resources. To get updates, please refresh the page.',
        linkToSelectProperty: 'Select Apaleo property',
    },
    LocationApaleoPropertyScreen: {
        title: 'Apaleo Properties',
        subtitle: 'Select One',
        left1: 'Link WeWash',
        left2: 'to Apaleo',
        cancel: 'Back',
        pages: 'Page:',
    },
    LocationApaleoPropertyList: {
        propertyId: 'Property ID',
        name: 'Name',
        postalCode: 'Postal Code',
        address: 'Address',
        linkButton: 'Link',
    },
    ChangeEmailForm: {
        title: 'Change e-mail address',
        sideTitle: 'Manage Account',
        cancel: 'cancel',
        activeRecordTitle: 'Login Details',
        expiredAt: 'The confirmation link is valid until %s.',
        requestedEmail: 'Requested change to e-mail address',
        currentEmail: 'Current e-mail address',
        newEmailHeader: 'New e-mail address',
        newEmailConfirmHeader: 'Confirm new e-mail address',
        requestButtonText: 'Request change',
        requestChangeButtonText: 'Update change request',
        editButtonText: 'Change e-mail address',
        unknownError: 'Somthing went wrong',
        duplicateEmail: 'This e-mail address is already used',
        invalidEmail: 'The provided e-mail address is invalid',
        missingEmail: 'There was no e-mail address provided',
        success:
            'We sent a validation e-mail to the new e-mail address. Please follow the instructions contained in it.',
    },
    ChangeEmailLandingPage: {
        title: 'Confirm the change of your e-mail address',
        sideTitle: 'Confirm change request',
        changeEmail: 'New e-mail address',
        currentEmail: 'Old e-mail address',
        confirmButtonText: 'Confirm change',
        reLogin: 'Proceed to log in',
        notFound: 'Code is wrong or expired',
        error: 'An error occurred',
        success: 'Your change was confirmed',
    },
    LoginActivationScreen: {
        cardTitle: 'Activate',
        cardSubtitle: 'Account',
        title: 'Activate Account',
        textLoading: 'Checking...',
        textExpired:
            'This activation link has expired. Please contact installation@we-wash.com to receive a new link.',
        textInfo:
            'Please provide a password to activate your account. Afterwards, you can always login with your e-mail address %s and that password.',
        fieldPassword: 'Password',
        fieldPasswordError: 'Please check the password rules.',
        hintPassword:
            'The password needs at least 8 characters, one number, and one special character.',
        fieldRepeatPassword: 'Repeat Password',
        fieldRepeatPasswordError: 'The passwords you provided do not coincide.',
        submit: 'Activate',
        submitInProgress: 'Activating...',
        genericError: 'Activation failed.',
        termsAndCond1: 'I hereby confirm that I have read and accepted the ',
        tac: 'Terms of Utilization and Ordering',
        tacUrlRoute: '/nutzungsbedingungen',
        pp: 'Privacy Policy',
        ppUrlRoute: '/datenschutz',
        and: ' and ',
        termsAndCond2: ' .',
        accept_tacError:
            'Please confirm that you have read and accepted the Terms of Utilization and Ordering and Privacy Policy.',
    },
    VipLaundryRoomInfoCard: {
        title: 'Laundry Room',
    },
    VipRemoveUserCard: {
        loading: 'loading current vip users....',
        remove: 'Select users to remove',
        title: 'Users Who Use Reduced Prices',
        description:
            'You can review existing users and also remove individual entries from the list.',
        errorLoading: 'Problem loading data',
        listHasMore: '... and %s more',
        noUsers: 'No users yet for reduced prices',
        removeAction: 'Remove',
        selectedCount: '%s user(s) selected for removal',
    },
    SelectLocationPricing: {
        title: 'Select Laundry Room',
        priceTitle: 'Set Prices',
        description: '',
        no_locations: 'Could not find any laundry rooms.',
        name: 'Name',
        address: 'Address',
        prices: 'Prices',
        washing: 'Washing',
        drying: 'Drying',
    },
    LocationPricing: {
        cancel: 'cancel',
        title: 'Laundry Room Prices',
        washing: 'washing',
        drying: 'drying',
    },
    LaundryRoomPricesCard: {
        washing: 'Price Washing (in %s)',
        drying: 'Price Drying (in %s)',
        washingVip: 'Reduced Price Washing (in %s)',
        dryingVip: 'Reduced Price Drying (in %s)',
        loading: 'Loading Prices...',
        loadingError: 'error loading data',
        error: 'Please input only a number - without the currency.',
        title: 'Laundry Room Prices',
        useVipPrices: 'Configure Reduced Prices',
        vipPricesKeep: 'Leave reduced prices unchanged',
        vipPricesChange: 'Change reduced prices',
        vipPricesConfigure: 'Configure reduced prices',
        vipPricesDisable: 'Disable reduced prices',
        vipPricesDoNotConfigure: 'Do not configure reduced prices',
        vipPricesKeepHint:
            'Only the regular prices will be changed. The reduced prices will remain as before.',
        vipPricesChangeHint:
            'The reduced prices will be adjusted with this price change.',
        vipPricesDisableHint:
            'The reduced prices will be disabled with this price change.',
        vipPricesDoNotConfigureHint: 'Only regular prices will be used.',
        configureVipSettings: 'Manage Reduced Prices',
        boxTitleCurrent: 'Current',
        boxTitleFuture: 'Upcoming',
        boxInfoNow: 'Today',
        boxInfoFuture: 'As of %s',
        scheduledInfoText:
            'Please remember to update any price information in the laundry room or other places ' +
            'yourself or take this opportunity to remove the price information outside the WeWash App for good.',
        scheduleLabel: 'When should the price change happen?',
        scheduleHintImmediately:
            'The price changes will take effect immediately.',
        scheduleHintDelayed:
            'We will inform the users in the app of the upcoming price change.',
        buttonRemove: 'Remove Price Change',
        buttonCancel: 'Cancel',
        buttonSave: 'Confirm Price Change',
        genericError: 'Something went wrong',
        pricesUnchangedError: 'Prices are unchanged',
        costCalculatorAction:
            'We offer you a tool to choose good prices. Click here to visit the Usage Price Calculator.',
        costCalculatorLink: 'https://we-wash.com/nutzungspreiskalkulator/',
    },
    SuggestedPriceIncreaseCard: {
        title: 'Review suggested Price Change',
        description: '',
        currentPrices: 'Current prices',
        weSuggest: 'We suggest the following prices',
        oldPriceWash: 'Price Washing',
        oldPriceDry: 'Price Drying',
        priceWash: 'Price Washing (in %s)',
        priceDry: 'Price Drying (in %s)',
        schedule: 'When should the price change happen?',
        hintImmediately: 'The price changes will take effect immediately.',
        hintDelayed:
            'We will inform the users in the app of the upcoming price change.',
        btnAccept: 'Confirm Price Change',
        btnReject: 'Ignore',
        btnGoToPricingScreen: 'Set Other Prices',
        genericError: 'Something went wrong. Please try again later.',
    },
    ScheduleTimeSelect: {
        IMMEDIATELY: 'Immediately',
        IN_SEVEN_DAYS: 'In 7 days',
        FIRST_OF_NEXT_MONTH: 'First of month',
    },
    RolesAddUserCard: {
        title: 'Invite',
        emailAddress: 'E-mail address',
        role: 'Role',
        subRole: 'Account Type',
        paymentConfirmation:
            'I accept that the costs for washing and drying cycles will be charged via the monthly credit notes.',
        success: 'Invite was sent successfully',
        errors: {
            UNKNOWN_ERROR: 'Something unexpected happened. Please try again.',
            NO_LOCATIONS_EXIST_FOR_SETUP_PROCESS:
                'No locations exist for this accounting area. Please add a location to the accounting area first.',
            USER_EMAIL_ALREADY_EXISTS: 'The provided e-mail is already taken',
            SETUP_PROCESS_EMAIL_AND_ROLE_NOT_UNIQUE:
                'A user with this e-mail address was already invited for the same role. In case you want to change the account type of an internal user account you first need to revoke their old role.',
            invalidEmail: 'The provided e-mail address is invalid.',
            duplicateEmail: 'The e-mail address is already taken.',
            B2B_LAUNDRY_USAGE_NOT_ALLOWED:
                'Users with this role cannot be added to this accounting area.',
            B2B_LAUNDRY_USAGE_NOT_ALLOWED_IN_COUNTRY:
                'This role is currently not supported in this country region.',
        },
    },
    RolesInviteWrapper: {
        title: 'Invite',
        back: 'Back to Access Management',
    },
    RolesInfoCard: {
        general: 'Here you manage access for this accounting area.',
        laundryUserTitle: 'Internal User Account',
        laundryUserBody1: ' Can book washing machines and dryers via the ',
        laundryUserBody2: 'Settlement is done via monthly credit notes.',
        laundryUserSubRole1:
            'Commercial (regular price) - Sale to third parties',
        laundryUserSubRole2a: 'Internal (reduced price)',
        laundryUserSubRole2b: '- Only for internal usage',
        laundryUserSubRole2Explanation:
            'Reduced prices can be configured per laundry room.',
        userAppLinkText: 'WeWash App',
    },
    UserActivationOverview: {
        tableTitle: 'Access Management',
        userEmailHeader: 'E-Mail Address',
        roleHeader: 'Role',
        statusHeader: 'Status',
        toAddUserForm: 'Invite',
        roleTranslations: {
            B2B_LAUNDRY_USAGE: 'Internal User Account',
        },
        subRoleTranslations: {
            RECEPTIONIST: 'Commercial',
            INTERNAL: 'Internal',
            HOUSEKEEPING: 'Free of charge (supplementary agreement)',
        },
        statusTranslations: {
            ERROR: 'Error',
            COMPLETED: 'Active',
            IN_PROGRESS: 'Invitation sent',
        },
        actionTranslations: {
            REVORKE: 'Revoke access',
        },
        confirmDeleteRoleMessage: 'Do you want to revoke the invitation of %s?',
    },
    PartnerInvoices: {
        title: 'Invoices',
        description: 'Overview of all invoices',
        noInvoices: 'No invoices found.',
        names: {
            UNKNOWN: 'Invoice',
            MINIMUM_USAGE: 'Minimum Usage',
        },
        accountingStatus: {
            INTERNAL: '',
            FILED: '',
            CANCELED: 'Canceled',
            CORRECTED: 'Canceled',
            CUSTOM_FILED: '',
        },
    },
    OperationalContactsList: {
        title: 'Contacts',
        objectsTitle: 'Objects',
        columns: {
            name: 'Name',
            role: 'Function',
            email: 'E-Mail',
            phone1: 'Phone 1',
            phone2: 'Phone 2',
        },
        noContacts: 'No contacts defined.',
        errorLoading: 'Error loading contacts.',
        createContact: 'Add contact',
    },
    OperationalContactRoleNames: {
        JANITOR: 'Janitor',
        RECEPTION: 'Reception',
        SERVICE_PROVIDER: 'Service Provider',
        ADMINISTRATIVE_CONTACT: 'Administrative Contact',
        OPERATIONAL_CONTACT: 'Operational Contact',
        PROPERTY_MANAGEMENT: 'Property Management',
        OTHER: 'Other',
    },
    OperationalContactSalutationNames: {
        undefined: '-- Please select --',
        FEMALE: 'Ms',
        MALE: 'Mr',
        UNSPECIFIED: 'Mx',
    },
    OperationalContactEdit: {
        title: 'Edit Contact',
        back: 'Back',
        labelName: 'Name*',
        errorName: 'Please provide a name.',
        labelFirstName: 'First Name',
        labelSalutation: 'Salutation',
        labelEmail: 'E-Mail Address',
        labelPhone1: 'Phone 1',
        labelPhone2: 'Phone 2',
        errorContactEmailOrPhone:
            'Please provide an e-mail address or a phone number.',
        labelRole: 'Function*',
        changedNote: 'Last changed at %s',
        errorTags: {
            UNKNOWN: 'A error occurred.',
            MISSING_CONTACT_INFO:
                'Please provide an e-mail address or a phone number.',
        },
        delete: 'Delete',
        deleteModal: {
            title: 'Delete Contact?',
            description:
                'Deleting a contact removes this person from all objects they have been assigned to. Also, the contact data will be removed.',
            confirm: 'Delete',
            cancel: 'Cancel',
        },
    },
    OperationalContactAssign: {
        title: 'Assign to Residential Properties',
        back: 'Back',
        errorAssign: 'An error occurred.',
        street: 'Street',
        city: 'City',
        countLocations: 'Laundry Rooms',
        checkAll: 'Select all',
        checkOneAria: 'Select this property',
    },
    OperationalContactCreate: {
        title: 'Add Contact',
        description:
            'Please provide an operational contact for each of your properties. We will contact this person regarding operational matters, e.g. if an appliance needs maintenance.',
        titleAssignments: 'Assign property responsibility',
        descriptionAssignments:
            'Select the properties this contact should be responsible for.',
        back: 'Cancel',
        actionCreate: 'Create',
        errorTags: {
            UNKNOWN: 'A error occurred.',
            MISSING_CONTACT_INFO:
                'Please provide an e-mail address or a phone number.',
        },
    },
    MansionToOperationalContactAssign: {
        title: 'Contacts',
        errorAssign: 'An error occurred.',
        name: 'Name',
        contactInformation: 'Contact Information',
        role: 'Function',
        actionCreate: 'Add another contact',
        checkAll: 'Select all',
        checkOneAria: 'Select this contact',
    },
    LocationPhoneUserCard: {
        title: 'Phone Users',
        description:
            'You can configure phone users by providing their e-mail address and phone number.',
        error: 'Something went wrong.',
        colEmail: 'E-Mail',
        colPhone: 'Phone',
        removeTitle: 'Remove Phone User?',
        removeDescription:
            'Do you want to remove this phone user, with phone number %s?',
        removeConfirm: 'Remove',
        removeCancel: 'Back',
        errorRemove: 'Failed to remove the phone user.',
        buttonAdd: 'Add Phone User',
    },
    LocationPhoneUserAddForm: {
        title: 'Add Phone User',
        description:
            'Add a phone user by providing their e-mail address and phone number.',
        fieldPhone: 'Phone',
        hintPhone: 'Format: +49 123 4567890',
        errorPhone: 'Please provide a valid phone number.',
        fieldEMail: 'E-Mail',
        errorEMail: 'Please provide a valid e-mail address.',
        termsAndConditions0: 'The user has agreed to the ',
        termsAndConditions1: 'Terms and Conditions',
        termsAndConditions2: ' and ',
        termsAndConditions3: 'Privacy Policy',
        termsAndConditions4: '.',
        termsAndConditionsLink: 'https://we-wash.com/en/terms-and-conditions/',
        privacyPolicyLink: 'https://we-wash.com/en/privacy-policy/',
        errorTermsAndConditions:
            "We require the user's consent to the Terms and Conditions.",
        buttonAdd: 'Add',
        buttonCancel: 'Cancel',
        errorGeneric: 'Something went wrong.',
        errorEMailAlreadyUsed: 'This e-mail address is already in use.',
        errorPhoneAlreadyUsed: 'This phone number is already in use.',
    },
} as const;
